import type { RefObject } from "react";
import { useEffect, useState } from "react";

export const useIsAtMaxScroll = (
  container: RefObject<HTMLDivElement | null>,
) => {
  const [isMax, setIsMax] = useState({ left: false, right: false });

  useEffect(() => {
    const containerRef = container.current;
    if (!containerRef) return;

    const update = () =>
      setIsMax({
        left: containerRef.scrollLeft <= 0,
        right:
          containerRef.scrollLeft !==
          containerRef.scrollWidth - containerRef.clientWidth,
      });

    // Initialize state booleans
    update();
    containerRef.addEventListener("scroll", update);

    return () => {
      containerRef.removeEventListener("scroll", update);
    };
  }, [container]);

  return { isMaxLeft: isMax.left, isMaxRight: isMax.right };
};
